import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './StationControlN.module.css';
import { useNavigate } from "react-router-dom";
import config from '../../../settings/config';
import { toast } from "react-toastify";
import Header from '../../Utils/Header/Header';
import useAuthToken from "../../../hooks/useAuthToken";
import useStateBackend from "../../../hooks/useStateBackend";
import Circle from './components/Circle';
import StationInfo from './components/StationInfo';
import StartButton from './components/StartButton';
import FinishingElement from './components/FinishingElement';
import FaultedElement from './components/FaultedElement';

const StationControlN = () => {
    let consLog = true;
    let lang = localStorage.getItem('language') === 'ru';
    const slaveId = 1;
    const navigate = useNavigate();
    const location = useLocation();
    const stationSn = location.state?.station?.sn || localStorage.getItem("stationSn");
    const [station, setStation] = useState();
    const [connector, setConnector] = useState();
    // const [status, setStatus] = useState("Faulted");
    const [status, setStatus] = useState();
    const [counter, setCounter] = useState(90);
    const [isRunningCounter, setIsRunningCounter] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPushButton, setIsPushButton] = useState(false);

    const toggleModal = () => {
        setIsModalOpen((prev) => !prev);
    };

    const token = useAuthToken();
    useStateBackend();

    useEffect(() => {
        let interval;
        if (isRunningCounter) {
            interval = setInterval(() => {
                setCounter((prevCounter) => {
                    if (prevCounter > 0) {
                        return prevCounter - 1;
                    } else {
                        clearInterval(interval);
                        return 0;
                    }
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [isRunningCounter]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${config.app.host}/api/v1/station/info?sn=${stationSn}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    const result = await response.json().catch(() => ({}));
                    const errorMessage = result?.message || `Ошибка: ${response.status}`;
                }

                const result = await response.json();

                setStation(result);
                setConnector(result?.connectors[0]);
                setStatus(result?.connectors[0]?.status);
            } catch (error) {
            }
        };
        fetchData();
        const intervalId = setInterval(fetchData, 5000);
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        if (station?.isAlive === false) {
            navigate('/myStations')
        }
    }, [station?.isAlive]);

    return (
        <div className={styles.container}>
            <Header title={station?.nickName} back={true} station={station} />
            {status === "Finishing" && (
                <div>
                    <FinishingElement connector={connector} />
                    <StartButton status={status} station={station} />
                </div>
            )}
            {status === "Faulted" && (
                <div>
                    <FaultedElement connector={connector} />
                    <StartButton status={status} station={station} />
                </div>
            )}
            {status !== "Finishing" && status !== "Faulted" && (
                <div>
                    <StationInfo status={station?.connectors[0]?.status} parameter={station?.connectors[0]?.type} />
                    <Circle status={station?.connectors[0]?.status} station={station} />
                    <StartButton status={status} station={station} />
                </div>
            )}
        </div>
    )
}

export default StationControlN;